<template>
  <div class="label_input_wrapper">
    <label class="f_gray_4"> {{ label }} </label>
    <input :placeholder="placeholder" :value="value" @input="handleChange"/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    //   required: true
    },
    label: {
      type: String,
    //   required: true
    },
    placeholder: {
      type: String,
      default: '입력'
    },
    onChange: {
      type: Function
    }
  },
  methods: {
    handleChange (e) {
      this.onChange(e)
    }
  }
}
</script>

<style scoped>
.label_input_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label_input_wrapper > label {
  min-width: 80px;
}
.label_input_wrapper > input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--gray-scale-7);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiLabelInput.vue